import React, { type ComponentPropsWithoutRef, type ReactNode } from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './Badge.module.css';

export type BadgeVariant = 'tertiary' | 'primary' | 'negative' | 'secondary';

export type BadgeSize = 'fit' | 'tight' | 'price';

const variantClass: Record<BadgeVariant, string | undefined> = {
    primary: undefined,
    secondary: styles.secondary,
    tertiary: styles.tertiary,
    negative: styles.negative,
};

const sizeClass: Record<BadgeSize, string> = {
    fit: styles.fit,
    tight: styles.tight,
    price: styles.price,
};

export interface BadgeProps extends Omit<ComponentPropsWithoutRef<'span'>, 'children'> {
    size?: BadgeSize;
    variant?: BadgeVariant;
    caption?: ReactNode;
    currencyValue?: string;
}

export const Badge = ({ size = 'fit', variant, caption, currencyValue, className, ...rest }: BadgeProps) => {
    return (
        <span className={clsx(styles.badge, variant && variantClass[variant], sizeClass[size], className)} {...rest}>
            {caption}
            {currencyValue && <span className={styles.currency}>{currencyValue}</span>}
        </span>
    );
};

Badge.propTypes = {
    size: PropTypes.oneOf(['fit', 'tight', 'price']),
    variant: PropTypes.oneOf(['tertiary', 'primary', 'negative', 'secondary']),
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currencyValue: PropTypes.string,
};
